import { describe, expect, it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  COMPANY_FIELDS,
  SOLD_TO_ADDRESS_FIELDS
} from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages, { type Card, type Field, type Page } from '..';

describe('Company Pages Template', () => {
  it('exports two pages', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(2);
  });

  describe('Company Page Template', () => {
    const companyPage = pages.find(
      page => page.route === PAGE_ROUTES.company
    ) as Page;

    it('has correct route', () => {
      expect(companyPage).toBeDefined();
      expect(companyPage.route).toBe(PAGE_ROUTES.company);
    });

    it('contains expected cards', () => {
      expect(Array.isArray(companyPage.cards)).toBe(true);
      expect(companyPage.cards).toHaveLength(4);
    });

    it('contains company card with correct fields', () => {
      const companyCard = companyPage.cards!.find(
        (card: Card) => card.key === CARD_CATEGORIES.company
      ) as Card;

      expect(companyCard).toBeDefined();
      expect(companyCard.fields?.map((f: Field) => f.key)).toEqual([
        COMPANY_FIELDS.tradeDbaName,
        COMPANY_FIELDS.legalName,
        COMPANY_FIELDS.parentCompany
      ]);
    });

    it('contains soldTo card with errorMustContain', () => {
      const soldToCard = companyPage.cards!.find(
        (card: Card) => card.key === CARD_CATEGORIES.soldTo
      ) as Card;

      expect(soldToCard).toBeDefined();
      expect(soldToCard.errorMustContain).toBe('address');
      expect(soldToCard.fields?.map((f: Field) => f.key)).toContain(
        SOLD_TO_ADDRESS_FIELDS.address
      );
    });

    it('contains additionalAttachmentCard', () => {
      const attachmentCard = companyPage.cards!.find(
        (card: Card) => card.key === CARD_CATEGORIES.additionalAttachmentCard
      ) as Card;

      expect(attachmentCard).toBeDefined();
      expect(attachmentCard.fields?.[0].key).toBe(
        ATTACHMENT_FIELDS.additionalAttachment
      );
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = companyPage.cards!.find(
        (card: Card) => card.key === CARD_CATEGORIES.privacyPolicy
      ) as Card;

      expect(privacyCard).toBeDefined();
      expect(privacyCard.fields).toBeUndefined();
    });
  });

  describe('Review Page Template', () => {
    const reviewPage = pages.find(
      page => page.route === PAGE_ROUTES.review
    ) as Page;

    it('has correct route', () => {
      expect(reviewPage).toBeDefined();
      expect(reviewPage.route).toBe(PAGE_ROUTES.review);
    });

    it('contains accordions', () => {
      expect(Array.isArray(reviewPage.accordions)).toBe(true);
      expect(reviewPage.accordions).toHaveLength(1);
    });

    it('accordion references company page cards', () => {
      const accordion = reviewPage.accordions![0];

      expect(accordion.title).toBe('tabTitles.company');
      expect(Array.isArray(accordion.cards)).toBe(true);
      expect(accordion.cards!.length).toBe(
        pages.find(p => p.route === PAGE_ROUTES.company)!.cards!.length
      );
    });
  });
});
